import React, {useState} from "react";
import './Contain.css';
import Profile from "./Profile";
import Logout from "./Logout";
import PuzzleUser from "../Games/Puzzle/PuzzleUser";
import AlbumUser from "./AlbumUser";


export default function ContainUser(props) {
    const ContainInfo = props.ContainInfo;
    const [ID] = useState(props.ID);

    if (ContainInfo==="Profile"){
        return (
        <div className="Contain-Box">
            <Profile ID={ID}/>
        </div>
        );
    }else if (ContainInfo==="Logout"){
        return (
        <div className="Contain-Box">
            <Logout />
        </div>
        );
    }else if (ContainInfo==="Puzzle"){
        return (
        <div className="Contain-Box">
            <PuzzleUser ID={ID}/>
        </div>
        );
    }else if (ContainInfo==="Album"){
        return (
        <div className="Contain-Box">
            <AlbumUser ID={ID}/>
        </div>
        );
    } 
}